import React from "react";
import { bgStyle } from "../lib/bgStyle";
import { ClockBadge } from "./ClockBadge";

// Continuous infinite ticker using CSS keyframes (no jitter).
// `bgOpacity` and `bgImage` optional, default to opaque solid color.
// `showClock` adds a fixed clock badge on the right edge.
export const Ticker = ({ messages = [], bgColor, textColor, bgOpacity = 1, bgImage = "", showClock = false }) => {
  const items = messages.length ? messages : ["—"];
  const joined = items.join("   •   ");
  return (
    <div
      className="w-full overflow-hidden whitespace-nowrap flex items-center relative"
      style={{ ...bgStyle(bgColor, bgOpacity, bgImage), color: textColor }}
      data-testid="ticker-bar"
    >
      <div className="ticker-track py-4 text-xl md:text-2xl font-medium tracking-wide flex-1">
        <span className="px-12">{joined}</span>
        <span className="px-12">{joined}</span>
        <span className="px-12">{joined}</span>
      </div>
      {showClock && (
        <div
          className="shrink-0 px-6 py-4 border-l border-current/20 font-heading font-black text-2xl md:text-3xl tracking-tight"
          style={{ backgroundColor: "rgba(0,0,0,0.15)" }}
        >
          <ClockBadge testId="ticker-clock" />
        </div>
      )}
    </div>
  );
};
